<template>
  <teleport to="body">
    <div v-if="visible" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="avisoNoListoTitulo">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="avisoNoListoTitulo" class="modal-title">El sistema todavía no está listo para vender</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="visible = false"></button>
          </div>
          <div class="modal-body">
            <p class="mb-2">Falta la configuración fiscal, así que las ventas no se van a poder facturar:</p>
            <ul class="mb-3">
              <li v-for="f in faltantes" :key="f.codigo">{{ f.mensaje }}</li>
            </ul>
            <p class="small text-muted mb-0">
              Avisá al administrador: se resuelve en <strong>Mantenimiento → Fiscal</strong>, cargando el archivo
              de configuración fiscal o los datos a mano. Mientras tanto se pueden cargar productos, stock y precios.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="visible = false">Entendido</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="visible" class="modal-backdrop fade show"></div>
  </teleport>
</template>

<script setup>
// FH-10 (SPEC_FIX_HEREDADOS_SUBS_v0.1.md): aviso al entrar a vender si falta la
// configuración fiscal. No bloquea la pantalla; si la consulta falla, no
// molesta (el cobro igual explica su error).
import { onMounted, ref } from 'vue'
import maintenanceFiscalService from '@/services/maintenanceFiscalService'
import operationalConfigService from '@/services/operationalConfigService'

const visible = ref(false)
const faltantes = ref([])

onMounted(async () => {
  try {
    const r = await maintenanceFiscalService.getPreparacion(operationalConfigService.getCurrentSucursalId())
    if (r && r.listo === false) {
      faltantes.value = r.faltantes || []
      visible.value = true
    }
  } catch (error) {
    console.warn('No se pudo verificar la configuración fiscal', error)
  }
})
</script>
